/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
const currentComorbChangesetKey = "comorbidities";
const ignoredComorbChangesetKey = "ignoredComorbidities";
let PathologyDetectionComponent = (_class = class PathologyDetectionComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "icd10", _descriptor2, this);
  }
  get patient() {
    return this.args.patient;
  }
  get changeset() {
    return this.args.changeset;
  }
  get currentSelectedComorbidities() {
    return this.changeset.get(currentComorbChangesetKey) || [];
  }
  get currentIgnoredComorbidities() {
    return this.changeset.get(ignoredComorbChangesetKey) || [];
  }

  /**
   * This method is a fake pathology detection method used only in demo ENV
   */
  get detectedPathologies() {
    let atcFoundDate = null;
    const hasDeliveries = this.args.patient.drugsAndDevicesRefundedJournalEvents && this.args.patient.drugsAndDevicesRefundedJournalEvents.some(je => je.prestations.some(prestation => {
      const medicationPresentation = this.store.peekRecord("medication-presentation", prestation.sourceValue);
      if (medicationPresentation.medicationSpecialty.medicationMolecule.atc.startsWith("A10")) {
        // If we found the code for the second time at a different day
        if (atcFoundDate && atcFoundDate.toDateString() != je.occurredAt.toDateString()) {
          return true;
        }
        atcFoundDate = je.occurredAt;
      }
      return false;
    }));
    if (hasDeliveries) {
      return ["E10", "E11"].filter(code => {
        return !this.currentSelectedComorbidities.includes(code) && !this.currentIgnoredComorbidities.includes(code);
      });
    }
    return [];
  }
  addComorbidity(code) {
    this.changeset.set(currentComorbChangesetKey, [...this.currentSelectedComorbidities, code]);
  }
  ignoreComorbidity(code) {
    this.changeset.set(ignoredComorbChangesetKey, [...this.currentIgnoredComorbidities, code]);
  }
  addComorbidities() {
    this.changeset.set(currentComorbChangesetKey, [...this.currentSelectedComorbidities, ...this.detectedPathologies]);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "icd10", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "addComorbidity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addComorbidity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ignoreComorbidity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "ignoreComorbidity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addComorbidities", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addComorbidities"), _class.prototype), _class);
export { PathologyDetectionComponent as default };